const isVisitor = deliveryIdentifierData => {
  const isSenderOfIncoming = deliveryIdentifierData.latestSenderOfIncomingMessage && !deliveryIdentifierData.latestSenderOfOutgoingMessage;
  const isRecipientOfOutgoing = deliveryIdentifierData.latestRecipientOfOutgoingMessage && !deliveryIdentifierData.latestRecipientOfIncomingMessage;
  return Boolean(isSenderOfIncoming || isRecipientOfOutgoing);
};
export const getAllVisitorDeliveryIdentifiers = threadDeliveryIdentifiers => {
  return threadDeliveryIdentifiers.filter(d => isVisitor(d));
};